import { render, staticRenderFns } from "./AccountCenter.vue?vue&type=template&id=3af05e15&scoped=true&"
import script from "./AccountCenter.vue?vue&type=script&lang=js&"
export * from "./AccountCenter.vue?vue&type=script&lang=js&"
import style0 from "./AccountCenter.vue?vue&type=style&index=0&id=3af05e15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af05e15",
  null
  
)

export default component.exports